import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  BookWidgetSearchModalComponent,
  PredictiveSearch,
  RecentListItem
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  GenericAction,
  MultiRoutePickerError,
  RoutePicker,
  RoutePickerCities,
  RoutePickerComponent,
  RoutePickerError,
  SelectedData,
  Tab
} from '@com-delta-omnichannel/mach';
import {
  PredictiveSearchItemSelectionEventData,
  SearchModalEvent,
  SearchModalEventType,
  TriggerLocation
} from '../../../models/search-modal-events-object.interface';
import { ErrorStateDirective, SwapIconClickDirective } from '../directive';

@Component({
  standalone: true,
  selector: 'idp-one-way-route-picker',
  templateUrl: './one-way-route-picker.component.html',
  styleUrls: ['./one-way-route-picker.component.scss'],
  imports: [
    RoutePickerComponent,
    SwapIconClickDirective,
    BookWidgetSearchModalComponent,
    ErrorStateDirective
  ]
})
export class OneWayRoutePickerComponent {
  private lastSearchModalTriggerLocation: TriggerLocation | undefined;
  protected modalOpen = false;
  protected error: RoutePickerError = {
    destination: false,
    origin: false,
    sameRoute: false,
    originErrorMessage: '',
    destinationErrorMessage: '',
    sameRouteErrorMessage: '',
    bothFieldsErrorMessage: ''
  };

  @Input() routePickerContent!: RoutePicker;
  @Input() routePickerCities!: RoutePickerCities;
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() searchModalTabs: Tab[] = [];
  @Input() predictiveSearchData!: PredictiveSearch;
  @Input() isFullscreen = false;

  @Input() set routePickerError(
    errorField: RoutePickerError[] | MultiRoutePickerError[] | undefined
  ) {
    if (errorField && errorField.length > 0) {
      const [
        {
          origin,
          destination,
          sameRoute,
          destinationErrorMessage,
          originErrorMessage,
          sameRouteErrorMessage,
          bothFieldsErrorMessage = ''
        }
      ] = errorField as RoutePickerError[];
      this.error = {
        origin,
        destination,
        sameRoute,
        destinationErrorMessage,
        originErrorMessage,
        sameRouteErrorMessage,
        bothFieldsErrorMessage
      };
    }
  }

  @Output() swapClicked = new EventEmitter<void>();
  @Output() searchModalTriggerClicked = new EventEmitter<SelectedData>();

  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  protected handleModalEvents(event: SearchModalEvent<SearchModalEventType>) {
    this.searchModalEvent.emit(event);
  }

  protected handleRoutePickerClick(data: SelectedData) {
    this.modalOpen = true;
    this.lastSearchModalTriggerLocation = data.type as TriggerLocation;
    this.searchModalEvent.emit({ type: 'modalOpen' });
    this.searchModalTriggerClicked.emit(data);
  }

  handleSearchModalClose(searchText: string) {
    if (searchText) {
      this.handlePredictiveSearchItemselection({
        label: searchText.toUpperCase(),
        id: searchText.toUpperCase(),
        value: ''
      });
    }
    this.modalOpen = false;
  }

  protected handlePredictiveSearchItemselection(
    eventData: GenericAction<string>
  ) {
    const data: PredictiveSearchItemSelectionEventData = {
      airportCode: eventData.label,
      airportCity: eventData.value ?? '',
      locationType: this.lastSearchModalTriggerLocation as TriggerLocation,
      flightIndex: 0
    };

    this.searchModalEvent.emit({
      type: 'predictiveSearchItemSelected',
      data
    });
  }
}
